import { DataBean } from "../DataBean";

export class CashResquestItem extends DataBean {

    public async getCashRequestItemCatalog(idCashRequest: number, cashRequestDate: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getCashRequestItemCatalog_Number_java.util.Date", [idCashRequest, cashRequestDate]);
    }
   public async getCashRequestItemCatalogByState(year:any,idAccount:any,idCashDeskAccount:any,idCashRequest:any,state:any,page:any,recordsPerPage:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.advantage.shared.Report_getCashRequestItemCatalogByState_Number_Number_Number_Number_Number_Number_Number", [year,idAccount,idCashDeskAccount,idCashRequest,state,page,recordsPerPage]);
    }
    public async deleteCashRequestItem(idCashRequestItem: number, since: any, idEmployee: number): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "void_deleteCashRequestItem_Number_java.util.Date_Number", [idCashRequestItem, since, idEmployee]);
    }

    public async updateCashRequestItem(bean: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.quickdataerp.bean.cashreimbursement.CashRequestItem_updateCashRequestItem_com.quickdataerp.bean.cashreimbursement.CashRequestItem", [
            {
                "DataBeanProperties": bean,
                "DataBeanName": "com.quickdataerp.bean.cashreimbursement.CashRequestItem"
            }
        ]);
    }

    public async processCashRequestItem(idCashRequestItem: number, cashRequestDate: any, idEmployee: number, observations: string): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.quickdataerp.bean.cashreimbursement.CashRequestItem_processCashRequestItem_Number_java.util.Date_Number_String", [idCashRequestItem, cashRequestDate, idEmployee, observations]);
    }

    public async rejectCashRequestItem(idCashRequestItem: number, cashRequestDate: any, idEmployee: number, observations: string): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.quickdataerp.bean.cashreimbursement.CashRequestItem_rejectCashRequestItem_Number_java.util.Date_Number_String", [idCashRequestItem, cashRequestDate, idEmployee, observations]);
    }

    public async addUBLInvoiceToCashRequest(idUBLInvoice: number, issueDate: any, idCashRequest: number, cashReimbursementDate: any, observations: string): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.quickdataerp.bean.cashreimbursement.CashRequestItem_addUBLInvoiceToCashRequest_Number_java.util.Date_Number_java.util.Date_String", [idUBLInvoice, issueDate, idCashRequest, cashReimbursementDate, observations]);
    }

    public async importUBLInvoiceToCashRequest(idCashRequest: number, cashRequestDate: any, media: string, mediaContext: string, dataStore: string, issueDate: any, invoiceID: string, value: number, observations: string, idProject: number, idBusinessCore: number): Promise<any> {
        return this.getCustomService(
            "QuickDataERPCore",
            "com.quickdataerp.bean.cashreimbursement.CashRequestItem_importUBLInvoiceToCashRequest_Number_java.util.Date_String_String_String_java.util.Date_String_Number_String_Number_Number",
            [idCashRequest, cashRequestDate, media, mediaContext, dataStore, issueDate, invoiceID, value, observations, idProject, idBusinessCore]
        );
    }

    public async createUBLInvoiceForCashRequest(idCashRequestItem: number, cashRequestDate: any, idAccountSupplier: number, idBusinessCore: number, idProject: number): Promise<any> {
        return this.getCustomService(
            "QuickDataERPCore",
            "com.quickdataerp.bean.ubl.UBLInvoice_createUBLInvoiceForCashRequest_Number_java.util.Date_Number_Number_Number",
            [idCashRequestItem, cashRequestDate, idAccountSupplier, idBusinessCore, idProject]
        );
    }

    public async createAccountantDocumentForCashRequestItem(idCashRequestItem: number, cashRequestDate: any, recordDate: any, idEmployee: number): Promise<any> {
        return this.getCustomService(
            "QuickDataERPCore",
            "com.quickdataerp.bean.ubl.UBLInvoice_createUBLInvoiceForCashRequest_Number_java.util.Date_Number_Number_Number",
            [idCashRequestItem, cashRequestDate, recordDate, idEmployee]
        );
    }
}
